import {
    createRouter,
    createWebHistory
} from 'vue-router'

import store from '@/store'
import storage from '@/util/storage'
// import { ref } from 'vue'



const routes = [
    {
        name: 'login',
        path: '/login',
        component: () => import('@/components/login'),
    },

    // {
    //     name: 'visual',
    //     path: '/visual',
    //     component: () => import('@/components/visual'),
    // },
   
    {
        name: 'main',
        path: '/main',
        component: () => import('@/components/main'),
        children: [
            {
                name: 'default',
                path: '/main/default',
                component: () => import('@/components/main/default'),  
            },
            {
                name: 'password',
                path: '/system/password',
                component: () => import('@/components/system/password'),
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

const routerPackag = (routers) => {
    routers.filter((itemRouter) => {
        if (itemRouter.component != "main" && itemRouter.path != "" && itemRouter.path != null) {
            router.addRoute('main', {
                path: `/${itemRouter.path}`,
                name: itemRouter.ename,
                // component: () => import(`@/${itemRouter.component}`)
                component: () => import(`@/components/${itemRouter.component}`),
            });
        }
        // 是否存在子集
        if (itemRouter.children && itemRouter.children.length) {
            routerPackag(itemRouter.children);
        }
        return true;
    });
};
//   const registerRouteFresh = ref(true) 

router.beforeEach((to) => {//to, from
    // console.log(name)
    // console.log(from)
    // if (to.name === 'login' || to.name==='visual') {
    if (to.name === 'login') {
        return true
    }

    if (!store.getters.isLogin) {
        if (!storage.getSessionObject('loginUser')) {
            router.push({ name: 'login' })
        } else {
            store.dispatch('RECOVERY_USER')
            store.dispatch('GET_ROLE_PERM')
            store.dispatch('GET_MENU').then(() => {//res
                // console.log('登录成功1-', res)
                // console.log('登录成功2-', store.getters.menus)
                routerPackag(store.getters.menus);

                // routerPackag(res.data.extend.permissions);
            })
            // let currentRouteName = storage.getSessionObject("currentRoute")

            // let currentRouteVisual = storage.getSessionObject("currentRouteVisual")
            // if (currentRouteVisual) {
                // if (typeof(to.name)==='undefined') {
                    router.push({ name: 'main' })
                // } else {
                    //router.push({ name: currentRouteVisual })
                // }
            // } else {
            //     router.push({ name: 'main' })

            // }
        }
    }
    // if (store.getters.isLogin && store.getters.menus.length>0 && !store.getters.menuRouteLoaded) {
    //     store.dispatch('GET_MENU').then((res) => {
    //         console.log('res已登录11-',res)
    //         // routerPackag(store.getters.menus);
    //         routerPackag(res.data.extend.permissions);
    //         store.dispatch('RECOVERY_MENUROUTELOADED')

    //         // registerRouteFresh.value = false
    //     })

    // }

    return true
})

export default router